import {ImageSize, ImageSizeGroup} from "@globals/functions/imageUtils";

// (Dish image is 7/12 of modal width for viewport widths >= 640px)
// For viewport widths >= 1250px, modal width is fixed at 1000px (image is 583px)
// For viewport widths between 640px and 1250px, modal width is 80% of viewport width (image is 299px - 583px)
// For viewport widths < 640px, dish image is full width of viewport (image is up to 640px)
export const qvImageSizes = `
  (min-width: 1251px) calc(1000px * (7 / 12)),
  (min-width: 641px) calc(80vw * (7 / 12)),
  100vw
`;

export default function getQVImageSizeGroup(): ImageSizeGroup {
  const ASPECT_RATIO = 1;
  const IMAGE_WIDTHS = [300, 400, 500, 583, 800, 1000, 1166];
  const MOBILE_EXCLUSIVE_IMAGE_WIDTHS = [1117, 1280];
  const imageSizes = IMAGE_WIDTHS.map(
    (width) => new ImageSize(width, Math.round(width / ASPECT_RATIO))
  );
  MOBILE_EXCLUSIVE_IMAGE_WIDTHS.forEach((width) => {
    imageSizes.push(
      new ImageSize(
        width,
        Math.round(width / ASPECT_RATIO),
        40 // We should use a lower quality, since this size will only ever be used on mobile
      )
    );
  });

  return new ImageSizeGroup(imageSizes);
}
